import { ShareAdapter } from "./ShareAdapter";
import { URLUtils } from "../../utils/URLUtils";
export class FacebookAppShareAdapter extends ShareAdapter {
    get scriptAdapter() {
        return this._fbScriptAdapter;
    }
    doInit() {
        this._scriptManager.activateScriptOnce({
            id: '',
            params: null,
            adapter: '__facebook'
        });
        this._fbScriptAdapter = this._scriptManager.getScripts('__facebook')[0];
        this._fbScriptAdapter.appInit(this._data.adapterData.params.app_id);
    }
    doShare(data) {
        if (data.url.indexOf('localhost')) {
            logger.error('cant share localhost url ' + data.url);
            if (URLUtils.isLocalhost) {
            }
        }
        this._fbScriptAdapter.appInit(this._data.adapterData.params.app_id).then(() => {
            this._fbScriptAdapter.FB.ui({
                method: 'feed',
                link: data.url,
                caption: data.title,
            }, function (response) {
            });
        });
    }
}
